import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-proof-image-dialog',
  standalone: true,
  imports: [MatDialogModule],
  template: `
    <h2 mat-dialog-title>Payment Proof</h2>
    <mat-dialog-content>
      <img [src]="data" alt="Payment proof" />
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styles: [`
    img {
      max-width: 100%;
      max-height: 70vh;
      object-fit: contain;
      display: block;
    }
  `]
})
export class ProofImageDialog {
  data = inject<string>(MAT_DIALOG_DATA);
}
